export default __webpack_public_path__ + "static/media/telegram.b2056dd6.svg";